export class SocialCredential {
    constructor(public email: string, public authToken: string) {}
}
